const easeInOutCubic = (progress) =>
  progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;

const animateScrollToTop = (duration = 500) => {
  const start = window.scrollY;

  if (start <= 0) {
    return;
  }

  const startTime = performance.now();

  const step = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOutCubic(progress);

    window.scrollTo(0, start * (1 - easedProgress));

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
};

class FloatingSidebar extends HTMLElement {
  #lastScrollY = 0;
  #onScroll = null;

  connectedCallback() {
    this.#lastScrollY = window.scrollY;
    this.classList.add('is-hidden');

    this.#onScroll = () => {
      const scrollY = window.scrollY;
      const threshold = Number.parseInt(this.dataset.scrollThreshold || '100', 10);
      const hideOnScroll = this.dataset.hideOnScroll !== 'false';

      if (scrollY <= 0) {
        this.classList.add('is-hidden');
      } else if (!hideOnScroll) {
        this.classList.remove('is-hidden');
      } else if (scrollY > this.#lastScrollY && scrollY > threshold) {
        this.classList.add('is-hidden');
      } else if (scrollY < this.#lastScrollY) {
        this.classList.remove('is-hidden');
      }

      this.#lastScrollY = scrollY;
    };

    window.addEventListener('scroll', this.#onScroll, { passive: true });

    this.querySelector('[data-back-to-top]')?.addEventListener('click', (event) => {
      event.preventDefault();
      animateScrollToTop();
    });
  }

  disconnectedCallback() {
    if (this.#onScroll) {
      window.removeEventListener('scroll', this.#onScroll);
    }
  }
}

if (!window.customElements.get('floating-sidebar')) {
  window.customElements.define('floating-sidebar', FloatingSidebar);
}
